import { ConferenceUser } from '@/api/conferences/structures';

export const sortNameAlphabetically = (userList: ConferenceUser[]): ConferenceUser[] => {
  return [...userList].sort((a, b) => {
    const first_user = a.display_name.toLowerCase();
    const second_user = b.display_name.toLowerCase();
    return first_user > second_user ? 1 : second_user > first_user ? -1 : 0;
  });
};
